<template>
  <page>
    <module enable-flex ref="view">
      <m-search ref="search" @search="searchHandle">
        <c-form ref="searchForm">
          <c-form-item type="input" label="会员信息" name="user_info" placeholder="昵称、手机号"></c-form-item>
          <c-form-item type="select" label="会员等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
          <c-form-item type="input" label="商品信息" name="product_info" placeholder="模糊匹配货号、名称"></c-form-item>
          <c-form-item type="input" label="商品规格" name="product_sku_spec"
                       placeholder="模糊匹配商品规格"></c-form-item>
          <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="精确匹配"></c-form-item>
        </c-form>
      </m-search>
      <m-operate>
        <c-button power="b_cloud_stock_import" @click="$refs.excelImport.open()" icon="upload" color="black">导入云仓库存</c-button>
        <c-button power="b_cloud_stock_export" color="m" hollow @click="syncExport()">导出库存数据</c-button>

        <template #right>
           <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
        </template>
      </m-operate>
      <c-table ref="table">
        <c-table-column type="selector"></c-table-column>

        <c-table-column label="会员头像/昵称" name="nick_name" width="200">
          <template v-slot="{data}">
            <div class="flex-center-cross">
              <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;">
              </c-image>
              <span>{{ data.nick_name || '--' }}</span>
            </div>
          </template>
        </c-table-column>

        <c-table-column label="会员手机号" name="user_manage_mobilephone" width="120">
          <template v-slot="{data}">
            <span>{{ data.user_manage_mobilephone }}</span>
          </template>
        </c-table-column>

        <c-table-column
            label="会员等级"
            name="level_name"
            width="80"
        ></c-table-column>

        <c-table-column
            label="商品信息"
            name="product_name"
            width="300"
        >
          <template v-slot="{data}">
            <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                          :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
          </template>
        </c-table-column>

        <c-table-column
            label="规格名称"
            name="product_sku_spec"
            width="150"
        ></c-table-column>

        <c-table-column
            label="SKU编码"
            name="product_sku_code"
            width="150"
        ></c-table-column>

        <c-table-column
            label="云仓库存"
            name="product_count"
            width="80"
        >
        </c-table-column>
      </c-table>
    </module>
    <excel-import ref="excelImport" :work-type="importWorkType" @resolve="$refs.table.update();"></excel-import>
  </page>
</template>
<script>
import {mapState} from "vuex";
import productInfo from '@/components/public/product_info.vue'
import excelImport from "@/components/service/import_excel_data.vue";  // 导入数据

export default {
  name: 'm_cloud_stock',

  components: {
      excelImport,
      productInfo
  },

  data() {
    return {
          workType:29,    //云仓库存业务代码
          isStock: [1],
          importWorkType:902
    }
  },

  computed: {
    ...mapState(['systemConfig', 'userInfo'])
  },

  watch: {},

  mounted() {
    this.$refs.search.search();
  },

  methods: {
    searchHandle(data = {}) {
      data.isStock = this.isStock;
      this.$refs.table.load({
        url: '/cloud/stock/list',
        data
      });
      this.searchDate = data;
    },
    /**同步导出数据*/
    syncExport() {
      var selectDatas = this.$refs.table.getRow('selected');
      var ids = [];
      if (selectDatas.length && selectDatas.length > 0) {
          ids = Array.from(selectDatas, item => item.data.id);
      }
      this.export(this.workType, this.searchParams, ids);
    }
  }
}
</script>

<style lang="stylus" scoped>
.tag {
  border-radius: 2px;
  padding: 0 5px;
  margin-left: 6px;
  line-height: 18px;
  color: #fff;
}
</style>